import { OWNER_PORTAL_DE_FALLBACK } from "./ownerPortalDeFallback";
import { SUPPORT_INBOX_DE_FALLBACK } from "./supportInboxDeFallback";

/**
 * German strings that must remain available while a translation migration is
 * rolling out or a cached dictionary is incomplete. Values fetched from the
 * translations table always win.
 */
const CLIENT_DE_FALLBACK: Record<string, string> = {
  ...OWNER_PORTAL_DE_FALLBACK,
  ...SUPPORT_INBOX_DE_FALLBACK,
};

export function mergeWithDeFallback(
  language: "en" | "de",
  dict: Record<string, string>
): Record<string, string> {
  if (language !== "de") return dict;
  return { ...CLIENT_DE_FALLBACK, ...dict };
}
